export default __webpack_public_path__ + "static/linkedInIcon-046551b0c1dec9274bbb8778ee3022a5.svg";